import SearchStatus from './search-status';

export default SearchStatus;
